export default __webpack_public_path__ + "static/media/logo-tall-dark.f55e3168.png";